import axios from "axios";
import { getAdminApiDomain } from "@/config/app.config";

const isBrowser = typeof window !== "undefined";

const apiBase = axios.create({
  // Browser usa proxy same-origin (/api) para que a sessao seja gravada com o
  // mesmo escopo de cookie do app web. Ver o comentario em `frontend.tsx`.
  baseURL: isBrowser ? "/api/" : getAdminApiDomain(),
  withCredentials: true,
  // Com 6s, um backend lento no SSR virava "logout" no guard de conta.
  timeout: 15000,
});

export default apiBase;
